import type { ComponentProps } from 'react';

import { SearchIcon } from '@change/ds-icons';

import { HeaderLayout, HeaderLayoutButton } from '@change/ds-layout/next';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { Dropdown } from './components/Dropdown';
import { Logo } from './components/Logo';
import { SAPButton } from './components/SAPButton';
import { useHeader } from './hooks/useHeader';

export const Header: React.FC<ComponentProps<'div'>> = (props) => {
	const {
		data: { navLinks, userIdentified, showMenu },
	} = useHeader();
	const { translate } = useI18n();
	return (
		<HeaderLayout
			logo={<Logo />}
			navLinks={navLinks}
			sapButton={showMenu && <SAPButton />}
			searchButton={
				showMenu && (
					<HeaderLayoutButton
						aria-label={translate('fe.components.header.search')}
						href="/search"
						qaAttribute="header-search-link"
						iconOnly
						leadingIcon={<SearchIcon />}
					/>
				)
			}
			userActionSlot={
				showMenu &&
				(userIdentified ? (
					<Dropdown />
				) : (
					<HeaderLayoutButton href="/login_or_join?user_flow=nav" qaAttribute="header-login-link">
						<Translate value="fe.components.header.log_in" />
					</HeaderLayoutButton>
				))
			}
			mobileMenu={showMenu && <Dropdown mobile />}
			{...props}
		/>
	);
};
